import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=a4d8bd9c&scoped=true"
import script from "./PageSizeSelect.ts?vue&type=script&lang=ts&external"
export * from "./PageSizeSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./PageSizeSelect.vue?vue&type=style&index=0&id=a4d8bd9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d8bd9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4d8bd9c')) {
      api.createRecord('a4d8bd9c', component.options)
    } else {
      api.reload('a4d8bd9c', component.options)
    }
    module.hot.accept("./PageSizeSelect.vue?vue&type=template&id=a4d8bd9c&scoped=true", function () {
      api.rerender('a4d8bd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UnprocessedFiles/components/PageSizeSelect/PageSizeSelect.vue"
export default component.exports